export async function fetchAddressByCep(zipcode) {
  const cleanCep = String(zipcode || "").replace(/\D/g, "");

  if (cleanCep.length !== 8) return null;

  const response = await fetch(`https://viacep.com.br/ws/${cleanCep}/json/`);
  const data = await response.json();

  if (data?.erro) return null;

  return {
    street: data.logradouro || "",
    neighborhood: data.bairro || "",
    city: data.localidade || "",
    state: data.uf || "",
  };
}
